export const getFileExtensionFromMimeType = (mimeType: string | undefined | null) => {
  if (!mimeType) {
    return null;
  }
  const parts = mimeType.split("/");
  if (parts.length === 2) {
    return parts[1];
  } else {
    // If the MIME type is not in the expected format, return null or handle the error accordingly.
    return null;
  }
}